export enum enumBeneficiaryType {
  'Normal' = 1,
  'Swift',
  'SMSPrinter'
}

export namespace enumBeneficiaryType {
  export function values() {
    return Object.keys(enumBeneficiaryType).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
